/**
 * 库的信号
 */

export const PYTHA_SINGAL = {
    // 图元位置移动
    onEntitiesMovePosition: "onEntitiesMovePosition",
}